/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowRight = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M14.3 6.7l-1.1 1.1 4 4H4v1.5h13.3l-4.1 4.4 1.1 1.1 5.8-6.3z" />
	</SVG>
);

export default arrowRight;
